import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { ArrowLeft } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { HELP_ZH, HELP_EN_SALES } from "./helpContent";

export default function Help() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isSales = user?.role === "sales";
  const [lang, setLang] = useState(isSales ? "en" : "zh");
  const content = lang === "en" ? HELP_EN_SALES : HELP_ZH;

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <header className="flex items-center justify-between border-b border-zinc-200 bg-zinc-50 px-4 py-3 md:px-6">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(-1)}
            className="rounded-sm"
            data-testid="help-back-button"
          >
            <ArrowLeft size={14} className="mr-1.5" />
            Back
          </Button>
          <h1 className="font-heading text-lg font-bold tracking-tight text-zinc-950">Help &amp; User Manual</h1>
        </div>
        <div className="flex items-center gap-1 rounded-sm border border-zinc-300 bg-white p-0.5" data-testid="help-lang-switch">
          <button
            type="button"
            onClick={() => setLang("zh")}
            className={`rounded-sm px-3 py-1 text-xs font-semibold uppercase tracking-[0.05em] transition-colors ${
              lang === "zh" ? "bg-blue-600 text-white" : "text-zinc-600 hover:bg-zinc-100"
            }`}
            data-testid="help-lang-zh"
          >
            中文
          </button>
          <button
            type="button"
            onClick={() => setLang("en")}
            className={`rounded-sm px-3 py-1 text-xs font-semibold uppercase tracking-[0.05em] transition-colors ${
              lang === "en" ? "bg-blue-600 text-white" : "text-zinc-600 hover:bg-zinc-100"
            }`}
            data-testid="help-lang-en"
          >
            English (Sales)
          </button>
        </div>
      </header>
      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-8 md:px-8" data-testid="help-content">
        <article className="prose prose-zinc max-w-none prose-headings:font-heading prose-headings:font-bold prose-h1:text-3xl prose-h2:text-2xl prose-h2:mt-8 prose-h3:text-xl prose-h3:mt-6 prose-a:text-blue-600 prose-a:no-underline hover:prose-a:underline prose-table:text-sm prose-th:bg-zinc-100 prose-th:px-3 prose-th:py-2 prose-td:px-3 prose-td:py-2 prose-td:border-zinc-200">
          <ReactMarkdown>{content}</ReactMarkdown>
        </article>
      </main>
    </div>
  );
}
